<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="open('add')"
        >添加</el-button
      >
      <el-button
        type="success"
        size="mini"
        
        @click="getList"
        >刷新</el-button
      >
      <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      > -->
      <el-button
        slot="reference"
        type="danger"
        size="mini"
        style="margin-left: 10px"
        @click="openDelete"
        >删除</el-button
      >
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1771px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="address" label="操作" width="120">
        <template slot-scope="scope">
          <div>
            <div>
              <el-button
            type="primary"
            class="edit-button"
            style="width: 90px;margin-bottom: 10px;"
            size="mini"
            @click="edit(scope.row)"
            >编辑</el-button
          >
            </div>
            <div>
              <el-button
            type="primary"
            class="edit-button"
             style="width: 90px;"
            size="mini"
            @click="receiveEdit(scope.row.id)"
            >挑战概率</el-button
          >
            </div>
          </div>
          
        </template>
      </el-table-column> 
      <el-table-column prop="id" label="升级包ID" width="100" />
      <el-table-column prop="name" label="名字" width="120" />
      <el-table-column prop="withdrawSum" label="图标" width="100">
        <template slot-scope="scoped">
          <el-image
            style="height: 60px"
            :src="scoped.row.image"
            fit="fill"
            :preview-src-list="new Array(scoped.row.vipImage)"
            @click.stop="handleClickItem"
          />
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格" width="100" />
      <el-table-column prop="reBuyPrice" label="回购价格" width="100" />
      <el-table-column prop="dayProfitBeStr" label="收益金额" width="120" />
      <el-table-column prop="beDayBeStr" label="回本周期" width="120" />
      <el-table-column prop="validDay" label="有效天数" width="100" />
      <el-table-column prop="cycleDay" label="收益周期" width="100" />
      <el-table-column prop="beDay" label="回本天数" width="100" />
      <el-table-column prop="needChildCount" label="需要下级购买指定升级包人数" width="130" />
      <el-table-column prop="maxBuyCount" label="每个用户最多购买多少个" width="120" />
      <el-table-column prop="price" label="月收益百分比" width="110">
        <template slot-scope="scope">
          <div>{{scope.row.monthPro}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="dayWith" label="每日提现额度" width="120" />
      <el-table-column prop="price" label="最高提现额度" width="120">
        <template slot-scope="scope">
          <div>{{scope.row.withMaxPro}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="subjectStr" label="锁定" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isLock" style="color:#06CC00">是</div>
          <div v-if="!scope.row.isLock" style="color:red">否</div>
        </template>
      </el-table-column>
      <el-table-column prop="subjectStr" label="是否上架" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isEnabled" style="color:#06CC00">上架</div>
          <div v-if="!scope.row.isEnabled" style="color:red">下架</div>
        </template>
      </el-table-column>
      <el-table-column prop="subjectStr" label="首页展示" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isIndex" style="color:#06CC00">是</div>
          <div v-if="!scope.row.isIndex" style="color:red">否</div>
        </template>
      </el-table-column>
      <el-table-column prop="orders" label="排序" width="100" />

    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="700px"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 表单 -->
      <el-form ref="form" :model="active" label-width="150px" size="mini">
        <el-form-item label="排序">
          <el-input v-model="active.orders" placeholder="请输入排序"/>
        </el-form-item>
        <el-form-item label="升级包名称">
          <el-input v-model="active.name" placeholder="请输入升级包名称"/>
        </el-form-item>
        <el-form-item label="图片">
          <UploadImage ref="image1" @upLoadImage="upLoadImage1"></UploadImage>
        </el-form-item>
        <el-form-item label="价格">
          <el-input v-model="active.price" placeholder="请输入价格" /> USDT
        </el-form-item>
        <el-form-item label="回购价格">
          <el-input v-model="active.reBuyPrice" placeholder="请输入回购价格" /> USDT
        </el-form-item>
        <el-form-item label="收益金额">
           <div class="table">
             <div class="table_tr1">
              <div class="table_td">商户等级</div>
              <div class="table_td1">收益金额</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">1</div>
              <div class="table_td1"><el-input v-model="active.lv1Profit" placeholder="请输入收益金额" /> USDT</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">2</div>
              <div class="table_td1"><el-input v-model="active.lv2Profit" placeholder="请输入收益金额" /> USDT</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">3</div>
              <div class="table_td1"><el-input v-model="active.lv3Profit" placeholder="请输入收益金额" /> USDT</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">4</div>
              <div class="table_td1"><el-input v-model="active.lv4Profit" placeholder="请输入收益金额" /> USDT</div>
             </div>
             <div class="table_tr">
              <div class="table_td">5</div>
              <div class="table_td1"><el-input v-model="active.lv5Profit" placeholder="请输入收益金额" /> USDT</div>
             </div>
           </div>
        </el-form-item>
        <el-form-item label="回本周期">
          <div class="table">
             <div class="table_tr1">
              <div class="table_td">商户等级</div>
              <div class="table_td1">天数</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">1</div>
              <div class="table_td1"><el-input v-model="active.lv1BeDay" placeholder="请输入回本周期" /> 天</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">2</div>
              <div class="table_td1"><el-input v-model="active.lv2BeDay" placeholder="请输入回本周期" /> 天</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">3</div>
              <div class="table_td1"><el-input v-model="active.lv3BeDay" placeholder="请输入回本周期" /> 天</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">4</div>
              <div class="table_td1"><el-input v-model="active.lv4BeDay" placeholder="请输入回本周期" /> 天</div>
             </div>
             <div class="table_tr">
              <div class="table_td">5</div>
              <div class="table_td1"><el-input v-model="active.lv5BeDay" placeholder="请输入回本周期" /> 天</div>
             </div>
           </div>
        </el-form-item>
        <el-form-item label="有效天数">
          <el-input v-model="active.validDay" placeholder="请输入有效天数" />
        </el-form-item>
        <el-form-item label="收益周期">
          <el-input v-model="active.cycleDay" placeholder="请输入收益周期" />
        </el-form-item>
        <el-form-item label="回本天数">
          <el-input v-model="active.beDay" placeholder="请输入回本天数" />
        </el-form-item>
        <div style="width: 100%;height: 1px;margin: 10px 0;border-top: 1px dashed #000;"></div>
        <el-form-item label="需要下级购买指定升级包人数">
          <el-input v-model="active.needChildCount" placeholder="请输入需要下级购买指定升级包人数" />
        </el-form-item>
         <el-form-item label="指定升级包ID">
          <el-input v-model="active.needPackageId" placeholder="请输入指定升级包ID" />
        </el-form-item>
        <el-form-item label="已购买多少个后限制需要下级购买">
          <el-input v-model="active.boughtNeedChildCount" placeholder="请输入已购买多少个后限制需要下级购买" />
        </el-form-item>
        <div style="width: 100%;height: 1px;margin: 10px 0;border-top: 1px dashed #000;"></div>
        <el-form-item label="每个用户最多购买多少个">
          <el-input v-model="active.maxBuyCount" placeholder="请输入每个用户最多购买多少个" />
        </el-form-item>
        <el-form-item label="月收益百分比">
          <el-input v-model="active.monthPro" placeholder="请输入月收益百分比" /> %
        </el-form-item>
        <el-form-item label="设置">
          <el-checkbox v-model="isEnabled">上架</el-checkbox>
          <el-checkbox v-model="isIndex">是否首页展示</el-checkbox>
           <el-checkbox v-model="isLock">是否锁定</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="bannerSave()">
            <el-button slot="reference" type="primary" class="edit-button"
              >添加</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :visible.sync="editDialogVisible"
      width="700px"
      title="编辑"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 表单 -->
      <el-form ref="form" :model="editForm" label-width="150px" size="mini">
        <el-form-item label="排序">
          <el-input v-model="editForm.orders" placeholder="请输入排序"/>
        </el-form-item>
        <el-form-item label="升级包名称">
          <el-input v-model="editForm.name" placeholder="请输入升级包名称"/>
        </el-form-item>
        <el-form-item label="图片">
          <UploadImage ref="image3" @upLoadImage="upLoadImage3"></UploadImage>
        </el-form-item>
        <el-form-item label="价格">
          <el-input v-model="editForm.price" placeholder="请输入价格" /> USDT
        </el-form-item>
        <el-form-item label="回购价格">
          <el-input v-model="editForm.reBuyPrice" placeholder="请输入回购价格" /> USDT
        </el-form-item>
        <el-form-item label="收益金额">
           <div class="table">
             <div class="table_tr1">
              <div class="table_td">商户等级</div>
              <div class="table_td1">收益金额</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">1</div>
              <div class="table_td1"><el-input v-model="editForm.lv1Profit" placeholder="请输入收益金额" /> USDT</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">2</div>
              <div class="table_td1"><el-input v-model="editForm.lv2Profit" placeholder="请输入收益金额" /> USDT</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">3</div>
              <div class="table_td1"><el-input v-model="editForm.lv3Profit" placeholder="请输入收益金额" /> USDT</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">4</div>
              <div class="table_td1"><el-input v-model="editForm.lv4Profit" placeholder="请输入收益金额" /> USDT</div>
             </div>
             <div class="table_tr">
              <div class="table_td">5</div>
              <div class="table_td1"><el-input v-model="editForm.lv5Profit" placeholder="请输入收益金额" /> USDT</div>
             </div>
           </div>
        </el-form-item>
        <el-form-item label="回本周期">
          <div class="table">
             <div class="table_tr1">
              <div class="table_td">商户等级</div>
              <div class="table_td1">天数</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">1</div>
              <div class="table_td1"><el-input v-model="editForm.lv1BeDay" placeholder="请输入回本周期" /> 天</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">2</div>
              <div class="table_td1"><el-input v-model="editForm.lv2BeDay" placeholder="请输入回本周期" /> 天</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">3</div>
              <div class="table_td1"><el-input v-model="editForm.lv3BeDay" placeholder="请输入回本周期" /> 天</div>
             </div>
             <div class="table_tr1">
              <div class="table_td">4</div>
              <div class="table_td1"><el-input v-model="editForm.lv4BeDay" placeholder="请输入回本周期" /> 天</div>
             </div>
             <div class="table_tr">
              <div class="table_td">5</div>
              <div class="table_td1"><el-input v-model="editForm.lv5BeDay" placeholder="请输入回本周期" /> 天</div>
             </div>
           </div>
        </el-form-item>
         <el-form-item label="有效天数">
          <el-input v-model="editForm.validDay" placeholder="请输入有效天数" />
        </el-form-item>
        <el-form-item label="收益周期">
          <el-input v-model="editForm.cycleDay" placeholder="请输入收益周期" />
        </el-form-item>
        <el-form-item label="回本天数">
          <el-input v-model="editForm.beDay" placeholder="请输入回本天数" />
        </el-form-item>
        <div style="width: 100%;height: 1px;margin: 10px 0;border-top: 1px dashed #000;"></div>
        <el-form-item label="需要本人购买机器数">
          <el-input v-model="editForm.needChildCount" placeholder="请输入需要本人购买机器数" />
        </el-form-item>
        <el-form-item label="指定升级包ID">
          <el-input v-model="editForm.needPackageId" placeholder="请输入指定升级包ID" />
        </el-form-item>
        <el-form-item label="已购买多少个后限制购买机器数">
          <el-input v-model="editForm.boughtNeedChildCount" placeholder="请输入已购买多少个后限制购买机器数" />
        </el-form-item>
        <div style="width: 100%;height: 1px;margin: 10px 0;border-top: 1px dashed #000;"></div>
        <el-form-item label="每个用户最多购买多少个">
          <el-input v-model="editForm.maxBuyCount" placeholder="请输入每个用户最多购买多少个" />
        </el-form-item>
        <el-form-item label="月收益百分比">
          <el-input v-model="editForm.monthPro" placeholder="请输入月收益百分比" /> %
        </el-form-item>
        <el-form-item label="设置">
          <el-checkbox v-model="editForm.isEnabled">上架</el-checkbox>
          <el-checkbox v-model="editForm.isIndex">是否首页展示</el-checkbox>
           <el-checkbox v-model="editForm.isLock">是否锁定</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="investUpdate()">
            <el-button slot="reference" type="primary" class="edit-button"
              >更新</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="receiveVisible"
      width="500px"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 表单 -->
      <div>
        <div style="font-weight: 600;text-align: center;margin-top: -40px;">挑战概率</div>
        <div style="text-align: center;color: red;margin: 20px 0;">注意：必须同时填了 显示概率、实际概率、领取金额 那行才起效</div>
        <div style="width: 100%;display: flex;align-items: center;justify-content: space-between;">
          <div style="font-weight: 600;text-align: center;width: 32%;">显示概率</div>
          <div style="font-weight: 600;text-align: center;width: 32%;">实际权重</div>
          <div style="font-weight: 600;text-align: center;width: 32%;">领取金额</div>
        </div>
        <div style="width: 100%;display: flex;align-items: center;justify-content: space-between;margin: 10px 0;" v-for="(item,index) in receiveList" :key='index'>
          <div style="font-weight: 600;text-align: center;width: 32%;display: flex;align-items: center;">
            <el-input  v-model="item.pro" placeholder="请输入概率" style="flex: 1" size="mini" clearable /> %
          </div>
          <div style="font-weight: 600;text-align: center;width: 32%;display: flex;align-items: center;">
            <el-input  v-model="item.nun" placeholder="请输入权重" style="flex: 1" size="mini" clearable />
          </div>
          <div style="font-weight: 600;text-align: center;width: 32%;display: flex;align-items: center;">
            <el-input  v-model="item.amount" placeholder="请输入金额" style="flex: 1" size="mini" clearable /> USDT
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: center;">
          <el-popconfirm title="确定更新？" @confirm="updateReceiveConfig()">
            <el-button slot="reference" type="primary" class="edit-button" >更新</el-button >
          </el-popconfirm>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module

import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap, UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: {},
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      yiFangDetailList: [], //
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      editDialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      isIndex: false, // 表格加
      buttongLoding: false, // 按钮加载
      num: 24,
      isCross: false,
      isRed: false,
      isLock: false,
      isEnabled: false,
      level:1,
      receiveVisible:false,
      receiveId:'',
      receiveList:[]
      
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    upLoadImage1(img) {
      this.active.image = img;
    },
    upLoadImage3(img) {
      this.editForm.image = img;
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    receiveEdit(id){
      this.receiveId = id
      this.$api.airdrop
        .receiveConfigView({
          id:id
        })
        .then((res) => {
          this.receiveVisible = true;
          let receiveList = res;
          let receiveList1 = []
          let item1 = {};
          let item2 = {};
          let item3 = {};
          let item4 = {};
          let item5 = {};
          let item6 = {};
          let item7 = {};
          let item8 = {};
          let item9 = {};
          let item10 = {};
          item1 = {
              pro:receiveList.length >= 1?receiveList[0].pro:'',
              nun:receiveList.length >= 1?receiveList[0].nun:'',
              amount:receiveList.length >= 1?receiveList[0].amount:""
          }
          receiveList1.push(item1)
           item2 = {
              pro:receiveList.length >= 2?receiveList[1].pro:'',
              nun:receiveList.length >= 2?receiveList[1].nun:'',
              amount:receiveList.length >= 2?receiveList[1].amount:""
          }
          receiveList1.push(item2)
           item3 = {
              pro:receiveList.length >= 3?receiveList[2].pro:'',
              nun:receiveList.length >= 3?receiveList[2].nun:'',
              amount:receiveList.length >= 3?receiveList[2].amount:""
          }
          receiveList1.push(item3)
          item4 = {
              pro:receiveList.length >= 4?receiveList[3].pro:'',
              nun:receiveList.length >= 4?receiveList[3].nun:'',
              amount:receiveList.length >= 4?receiveList[3].amount:""
          }
          receiveList1.push(item4)
          item5 = {
              pro:receiveList.length >= 5?receiveList[4].pro:'',
              nun:receiveList.length >= 5?receiveList[4].nun:'',
              amount:receiveList.length >= 5?receiveList[4].amount:""
          }
          receiveList1.push(item5)
          item6 = {
              pro:receiveList.length >= 6?receiveList[5].pro:'',
              nun:receiveList.length >= 6?receiveList[5].nun:'',
              amount:receiveList.length >= 6?receiveList[5].amount:""
          }
          receiveList1.push(item6)
          item7 = {
              pro:receiveList.length >= 7?receiveList[6].pro:'',
              nun:receiveList.length >= 7?receiveList[6].nun:'',
              amount:receiveList.length >= 7?receiveList[6].amount:""
          }
          receiveList1.push(item7)
          item8 = {
              pro:receiveList.length >= 8?receiveList[7].pro:'',
              nun:receiveList.length >= 8?receiveList[7].nun:'',
              amount:receiveList.length >= 8?receiveList[7].amount:""
          }
          receiveList1.push(item8)
          item9 = {
              pro:receiveList.length >= 9?receiveList[8].pro:'',
              nun:receiveList.length >= 9?receiveList[8].nun:'',
              amount:receiveList.length >= 9?receiveList[8].amount:""
          }
          receiveList1.push(item9)
          item10 = {
              pro:receiveList.length >= 10?receiveList[9].pro:'',
              nun:receiveList.length >= 10?receiveList[9].nun:'',
              amount:receiveList.length >= 10?receiveList[9].amount:""
          }
          receiveList1.push(item10)
          this.receiveList = receiveList1
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
        });
    },
    // 编辑
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.editDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.image3.init(this.editForm.image);
      });
    },
    updateReceiveConfig(){
      let editForm = {}
      editForm.id = this.receiveId
      if(this.receiveList.length >= 1){
        editForm.pro1 = this.receiveList[0].pro
        editForm.nun1 = this.receiveList[0].nun
        editForm.amount1 = this.receiveList[0].amount
      }
      if(this.receiveList.length >= 2){
        editForm.pro2 = this.receiveList[1].pro
        editForm.nun2 = this.receiveList[1].nun
        editForm.amount2 = this.receiveList[1].amount
      }
      if(this.receiveList.length >= 3){
        editForm.pro3 = this.receiveList[2].pro
        editForm.nun3 = this.receiveList[2].nun
        editForm.amount3 = this.receiveList[2].amount
      }
      if(this.receiveList.length >= 4){
        editForm.pro4 = this.receiveList[3].pro
        editForm.nun4 = this.receiveList[3].nun
        editForm.amount4 = this.receiveList[3].amount
      }
      if(this.receiveList.length >= 5){
        editForm.pro5 = this.receiveList[4].pro
        editForm.nun5 = this.receiveList[4].nun
        editForm.amount5 = this.receiveList[4].amount
      }
      if(this.receiveList.length >= 6){
        editForm.pro6 = this.receiveList[5].pro
        editForm.nun6 = this.receiveList[5].nun
        editForm.amount6 = this.receiveList[5].amount
      }
      if(this.receiveList.length == 7){
        editForm.pro7 = this.receiveList[6].pro
        editForm.nun7 = this.receiveList[6].nun
        editForm.amount7 = this.receiveList[6].amount
      }
      if(this.receiveList.length >= 8){
        editForm.pro8 = this.receiveList[7].pro
        editForm.nun8 = this.receiveList[7].nun
        editForm.amount8 = this.receiveList[7].amount
      }
      if(this.receiveList.length >= 9){
        editForm.pro9 = this.receiveList[8].pro
        editForm.nun9 = this.receiveList[8].nun
        editForm.amount9 = this.receiveList[8].amount
      }
       if(this.receiveList.length >= 10){
        editForm.pro10 = this.receiveList[9].pro
        editForm.nun10 = this.receiveList[9].nun
        editForm.amount10 = this.receiveList[9].amount
      }
      this.$api.airdrop
        .updateReceiveConfig(editForm)
        .then((res) => {
          this.$message.success(res);
          this.receiveVisible = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });

    },
    investUpdate() {
      this.$api.airdrop
        .update(this.editForm)
        .then((res) => {
          this.$message.success(res);
          this.editDialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.airdrop
        .list(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.airdrop
        .tradeTicketDelete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开添加弹窗
    open() {
      this.dialogVisible = true;
      this.isEnabled = false
      this.isLock = false
      this.isIndex = false
      this.active = {}
      this.$nextTick(() => {
        this.$refs.image1.init('');
        this.$refs.image2.init('');
      });
    },
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + "-" + MM + "-" + d;
    },
    // 添加用户
    bannerSave() {
      this.active.isEnabled = this.isEnabled
      this.active.isIndex = this.isIndex
      this.active.isLock = this.isLock
      this.$api.airdrop
        .save(this.active)
        .then((res) => {
          this.$message.success(res);
          this.dialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 打开删除弹窗
    openDelete() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.table{
  border: 1px solid #000;
}
.table_tr{
  display: flex;
  align-items: center;
}
.table_tr1{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #000;
}
.table_td{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  border-right: 1px solid #000;
  padding: 5px 10px;

}
.table_td1{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  padding: 5px 10px;
}
</style>
